<template>
  <DragPanel
    ref="dragPanel"
    title="图层"
    :closePanel="closePanel"
    :limitDragArea="limitDragArea">
    <div class="layer-box">
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          v-model="keywords"
          placeholder="请输入图层名称搜索"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search icon"
            @click="search" />
        </el-input>
      </div>
      <div class="checkbox-box">
        <div class="common-checkbox-box">
          <el-checkbox
            class="checkbox-primary"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange">
            全部图层
          </el-checkbox>
        </div>
        <div class="checkbox-group-box">
          <el-checkbox-group
            class="checkbox-primary"
            v-model="checkedLayers"
            @change="handleCheckedLayerChange">
            <div
              class="common-checkbox-box"
              v-for="(layer, index) in filterLayerList"
              :key="index">
              <el-checkbox
                :label="layer.layerId"
                @change="value => handleCheckboxChange(value, layer)">
                <div class="layer-info-box">
                  <div
                    class="layer-style"
                    :style="`background:${layer.layerStyle}`"></div>
                  <div
                    class="layer-name text-overflow"
                    :title="layer.layerName">
                    {{ layer.layerName }}
                  </div>
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
export default {
  data() {
    return {
      checkAll: true,
      isIndeterminate: false,

      keywords: '',
      allLayerList: [],
      filterLayerList: [],
      checkedLayers: []
    }
  },
  props: {
    limitDragArea: String,
    closePanel: Function
  },
  components: {
    DragPanel
  },
  mounted() {
    this.initCadLayerList()

    this.$nextTick(() => {
      let dataType = this.$route.query.dataType
      if (dataType === 'Cad') {
        let dom = this.$refs.dragPanel.$el
        if (dom) {
          dom.style.left = '10px'
        }
      }
    })
  },
  methods: {
    initCadLayerList() {
      const BlackHole3D = window.BlackHole3D
      let layerList = []
      let allLayers = BlackHole3D.CAD.getCurAllLayer()
      layerList = allLayers.map(item => {
        let color = item.color
        let layerStyle = `rgb(${color.red}, ${color.green}, ${color.blue})`
        let obj = {
          layerId: item.layerId,
          layerName: item.layerName,
          layerHide: item.layerHide,
          layerStyle
        }
        return obj
      })
      this.allLayerList = layerList
      this.filterLayerList = layerList
      this.checkedLayers = layerList.map(el => el.layerId)
    },
    handleCheckAllChange(value) {
      const BlackHole3D = window.BlackHole3D
      if (value) {
        this.filterLayerList.forEach(item => {
          let layerId = item.layerId
          BlackHole3D.CAD.setLayerVisible(layerId, true)
        })
      } else {
        this.filterLayerList.forEach(item => {
          let layerId = item.layerId
          BlackHole3D.CAD.setLayerVisible(layerId, false)
        })
      }
      let checkedLayers = this.filterLayerList.map(el => el.layerId)
      this.checkedLayers = value ? checkedLayers : []
      this.isIndeterminate = false
    },
    handleCheckedLayerChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.filterLayerList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.filterLayerList.length
    },
    handleCheckboxChange(value, layer) {
      const BlackHole3D = window.BlackHole3D
      let layerId = layer.layerId
      if (value) {
        BlackHole3D.CAD.setLayerVisible(layerId, true)
      } else {
        BlackHole3D.CAD.setLayerVisible(layerId, false)
      }
    },
    search() {
      let layerList = this.allLayerList.filter(el =>
        el.layerName.includes(this.keywords)
      )
      this.filterLayerList = layerList
      this.checkedLayers = layerList.map(el => el.layerId)
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 60px;
  left: calc(50% + 10px);
  width: 290px;
  height: calc(100% - 125px);

  /deep/ .content {
    height: calc(100% - 45px);
    padding: 15px;

    .layer-box {
      height: 100%;
      text-align: left;
      .checkbox-box {
        height: calc(100% - 40px);
        margin-top: 10px;

        .checkbox-group-box {
          height: calc(100% - 20px);
          margin-left: 25px;
          overflow-y: auto;

          .common-checkbox-box {
            margin-right: 20px;
            .el-checkbox {
              width: 100%;

              .el-checkbox__label {
                width: 100%;
              }
            }
            .layer-info-box {
              display: flex;
              align-items: center;
              overflow: hidden;

              .layer-style {
                width: 10px;
                height: 10px;
              }

              .layer-name {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
